export default [
    'Investment Sales',
    'Leasing',
    'Financing',
    'Advisory',
    'Referral'
];